import { useQuery } from '@tanstack/react-query';

import { fetchEventsAttended } from '../services/endpoints';
import { EventQuery } from '../types';
import { buildQuery } from '../utils';

export interface EventData {
  id: string;
  name: string;
  email: string;
  date: string;
  slug: string;
  startTime: string;
  endTime: string;
  externalId: string;
  activityType?: string;
  eventSeries?: Array<{
    externalId: string;
    name: string;
  }>;
}

export const useEventsAttended = (
  config: EventQuery,
  queryName: string,
  slug: string,
  isOpen: boolean,
) => {
  return useQuery<EventData[]>(
    [queryName, config],
    async () => {
      const events = await fetchEventsAttended(buildQuery(config));
      return events.filter((event: EventData) => event.slug !== slug);
    },
    {
      enabled: isOpen && !!config.emailId,
      retry: (failureCount, error) => {
        // Only retry if the error is NOT 401 (Unauthorized)
        if ((error as any).response?.status === 401) {
          return false;
        }
        return failureCount < 3; // Retry up to 3 times for other errors, here 3 is default value for useQuery failureCount
      },
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
